module.exports = __webpack_public_path__ + "img/logo_personajes_sm.74014bba.svg";